import { HashLink } from "react-router-hash-link"
import arrowRight from "../../assets/arrow-right.svg"

type BasePrimaryButtonType = {
    text: string
    url?: string
    onClick?: () => void
    classProps?: string
    ghost?: boolean
}

export default function BasePrimaryButton(props: BasePrimaryButtonType) {
    if (props.onClick) {
        return (
            <button
                onClick={props.onClick}
                className={`${props.classProps} ${props.ghost ? "bg-transparent border border-primary text-primary" : "bg-primary"} flex items-center py-3 px-8 rounded-3xl w-fit gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                <p className="lowercase text-accent">{props?.text}</p>
            </button>
        )
    }
    if (props.url) {
        return (
            <HashLink
                to={props.url}
                className={`${props.classProps} bg-primary flex items-center py-3 px-8 rounded-3xl w-fit gap-4 transition-all ease-in duration-300 group border border-transparent hover:bg-base-100 hover:border hover:border-secondary`}>
                <p className="lowercase text-accent">{props?.text}</p>
                <img src={arrowRight} alt="Pfeil Rechts" className="group-hover:translate-x-1 transition-all ease-in duration-200 pt-[2px]" />
            </HashLink>
        )
    }
    return null;
}
